function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.679 12.2l.018-.017a.751.751 0 00.018-1.043l-2.029-2.174a.249.249 0 010-.341l2.028-2.174a.75.75 0 00-1.078-1.043l-.018.019-2.666 2.856a.752.752 0 000 1.025l2.666 2.857a.752.752 0 001.061.035zM16.286 11.14a.75.75 0 001.078 1.043l.018-.018 2.666-2.857a.752.752 0 000-1.025l-2.666-2.856a.751.751 0 00-1.061-.036.731.731 0 00-.062 1.032l.026.028 2.029 2.174a.249.249 0 010 .341z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.414 3L21 .587A2 2 0 0019.586 0H8a2 2 0 00-2 2v7.214a.248.248 0 00.242.25 19.14 19.14 0 011.485.082A.246.246 0 008 9.3V2.5a.5.5 0 01.5-.5h10.879a.5.5 0 01.353.146l2.122 2.121a.5.5 0 01.146.355V18a.5.5 0 01-.5.5h-6.869a.244.244 0 00-.241.208 7.983 7.983 0 01-.373 1.459.243.243 0 00.228.332H22a2 2 0 002-2V4.415A2 2 0 0023.414 3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 11a6.5 6.5 0 106.5 6.5A6.5 6.5 0 006.5 11zm2.496 9.259a.735.735 0 11-1.47 0v-1.93c0-.161-.173-.096-.22 0l-.15.304a.761.761 0 01-1.315 0s-.117-.222-.16-.322-.211-.078-.211.012v1.936a.735.735 0 11-1.47 0V14.74a.734.734 0 011.392-.331s.878 1.76.933 1.883a.213.213 0 00.299.05.215.215 0 00.054-.058l.93-1.875a.732.732 0 01.986-.332.742.742 0 01.406.663z"
});

function SvgSpMenuMeme(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "spMenuMeme.fa44d.svg";
export { SvgSpMenuMeme as ReactComponent };